import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useEventCallback } from '../useEventCallback';
export function useModalLifecycleEffect(t0) {
  const $ = _c(6);
  const {
    opened,
    afterOpened
  } = t0;
  let t1;
  if ($[0] !== afterOpened) {
    t1 = () => {
      afterOpened();
    };
    $[0] = afterOpened;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpened = useEventCallback(t1);
  let t2;
  let t3;
  if ($[2] !== handleOpened || $[3] !== opened) {
    t2 = () => {
      if (opened) {
        handleOpened();
      }
    };
    t3 = [opened, handleOpened];
    $[2] = handleOpened;
    $[3] = opened;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
}